import { bugsnagClient } from '@/bugsnag';

import { createRouter, createWebHistory } from 'vue-router';

import store from '@/vuex/index';

import EventBus from '@/event-bus';

import Lang from '@/lang';

import _ from '@/lodash';

const { user, reviews } = store.state;

function loadReviewData(next, { id }) {
  return store.dispatch('reviews/getReviewById', { id: +id })
    .then(() => {
      next();
    })
    .catch((error) => {
      const status = _.get(error, 'status', false);

      if (status === 404) {
        next({ name: '404' });
      } else if (status === 403) {
        next({ name: '403' });
      // RMA-1546 - error handling for timedout sessions
      } else if (status === 401 || status === 419) {
        window.location.replace('/rate-your-apprenticeship');
      } else {
        bugsnagClient.notify(new Error('Review loadReviewData error'), {
          metaData: {
            'axios-error': error.data,
          },
        });
      }

      next(false);

      EventBus.$emit('bus:base-alert', {
        type: 'Error',
        message: Lang.generic.error,
      });
    });
}

function requireAuth(next, userData) {
  if (!userData.loggedIn) {
    console.log('requires auth');
    next({ name: 'authentication' });
  }
}

const baseUrl = '/rate-your-apprenticeship';
const reviewRouter = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: `${baseUrl}`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/authentication.vue'),
      name: 'authentication',
      beforeEnter: (to, from, next) => {
        if (user.loggedIn && reviews.unfinishedReviews.length) {
          next({ name: 'incompleteReviews' });
        } else if (user.loggedIn) {
          next({ name: 'jobDetails' });
        }

        next();
      },
    },
    {
      path: `${baseUrl}/incomplete-reviews`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/incomplete-reviews-template.vue'),
      name: 'incompleteReviews',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);

        next();
      },
    },
    {
      path: `${baseUrl}/job-details`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/review-details.vue'),
      name: 'jobDetails',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);
        // console.log(reviews, store.state);
        if (user.loggedIn && reviews.unfinishedReviews.length >= reviews.reviewLimit) {
          next({ name: 'incompleteReviews' });
        }

        store.commit('reviews/resetReviewState');

        next();
      },
    },
    {
      path: `${baseUrl}/:id/job-details`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/review-details.vue'),
      name: 'existingJobDetails',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);

        // console.log('continue');

        loadReviewData(next, { id: to.params.id });
      },
    },
    {
      path: `${baseUrl}/:id/review-start`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/review-start.vue'),
      name: 'reviewStart',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);

        // TODO: no direct access if you havent completed previous stage

        loadReviewData(next, { id: to.params.id });
      },
    },
    {
      path: `${baseUrl}/:id/review-questions`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/review-questions.vue'),
      name: 'reviewQuestions',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);

        // TODO: no direct access if you havent completed previous stage

        loadReviewData(next, { id: to.params.id });
      },
    },
    {
      path: `${baseUrl}/:id/review-overview`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/review-overview.vue'),
      name: 'reviewOverview',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);

        // TODO: no direct access if you havent completed previous stage

        loadReviewData(next, { id: to.params.id });
      },
    },
    {
      path: `${baseUrl}/:id/review-complete`,
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/review-process/stages/review-complete.vue'),
      name: 'reviewComplete',
      beforeEnter: (to, from, next) => {
        requireAuth(next, user);

        // TODO: no direct access if you havent completed previous stage

        loadReviewData(next, { id: to.params.id });
      },
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/error-pages/404.vue'),
      name: '404',
    },
    {
      path: '/403',
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/error-pages/403.vue'),
      name: '403',
    },
    {
      path: '/*',
      component: () => import(/* webpackChunkName: "group-review" */ '@/components/error-pages/404.vue'),
      name: '404a',
    },
  ],
});

reviewRouter.afterEach(() => {
  try {
    window.gtag.send({
      event: document.title,
      action: 'page_view',
      category: window.location.pathname,
      location: window.location.href,
    });
  } catch (e) {
    console.log(e);
  }
});

export default reviewRouter;
